var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export function toArray(arr) {
    if (arr === undefined || arr === null) {
        return [];
    }
    return (Array.isArray(arr) ? arr : [arr]);
}
export function getColumnsKey(columns) {
    const columnKeys = [];
    const keys = {};
    columns.forEach((column) => {
        const { key, dataIndex } = column || {};
        let mergedKey = key || toArray(dataIndex).join('-') || 'test_';
        while (keys[mergedKey]) {
            mergedKey = `${mergedKey}_next`;
        }
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
export function convertChildrenToColumns(children) {
    return toArray(children)
        .filter((node) => React.isValidElement(node))
        .map(({ key, props }) => {
        const { children: nodeChildren } = props, restProps = __rest(props, ["children"]);
        const column = Object.assign({ key }, restProps);
        if (nodeChildren) {
            column.children = convertChildrenToColumns(nodeChildren);
        }
        return column;
    });
}
export function* getDirectionGenerator(direction) {
    let counter = 0;
    if (!direction || direction.length === 0) {
        while (true) {
            yield 'descend';
        }
    }
    while (true) {
        yield direction[counter % direction.length];
        counter += 1;
    }
}
export function getPathValue(record, path) {
    if (!path && typeof path !== 'number') {
        return record;
    }
    const pathList = toArray(path);
    let current = record;
    for (let i = 0; i < pathList.length; i += 1) {
        if (!current) {
            return null;
        }
        const prop = pathList[i];
        current = current[prop];
    }
    return current;
}
export function isRenderCell(data) {
    return data && typeof data === 'object' && !Array.isArray(data) && !React.isValidElement(data);
}
export function validateValue(val) {
    return val !== null && val !== undefined;
}
export function getSorters(baseColumns) {
    const results = {};
    baseColumns.forEach(({ sorter, sortDirections, dataIndex }) => {
        results[String(dataIndex)] = {
            sorterFn: sorter,
            directionGenerator: getDirectionGenerator(sortDirections),
            sortDirections,
        };
    });
    return results;
}
